import React from 'react';

const PageTitlePolicy = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large text-uppercase">Integritetspolicy</h1>
            </div>
        </div>
    );
};

export default PageTitlePolicy;
